import { FETCH_PARTICIPANTS_SUCCESS } from '../constants/actionTypes';

const initialState = {
  participantList: [],
  participantCount: 0
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        participantList: payload.participantList,
        participantCount: payload.participantCount
      };

    default:
      return state;
  }
}
